import React from 'react';
import { Container, makeStyles, Typography } from "../../../../index";
import classNames from 'classnames';
import { PmlAssignmentAccordion } from "./PmlAssignmentAccordion";
var useStyles = makeStyles(function (theme) { return ({
    root: {},
    accordion: {
        marginBottom: theme.spacing(1),
    },
}); });
/**
 * 情報活用の課題アコーディオン群のコンポーネント
 */
export var PmlAssignmentCourseContents = function (props) {
    var className = props.className, courseIndex = props.courseIndex, defaultOpenIndex = props.defaultOpenIndex, groups = props.groups, kind = props.kind, onSelectCourse = props.onSelectCourse, title = props.title, viewMoralContentForMiddleSchool = props.viewMoralContentForMiddleSchool;
    var classes = useStyles();
    return (React.createElement(Container, { className: classNames(classes.root, className) },
        title && (React.createElement(Typography, { variant: 'body1', bold: true }, title)),
        groups.map(function (group, index) {
            if (group.targetSchoolType === 'MIDDLE_SCHOOL' && !viewMoralContentForMiddleSchool) {
                // 表示が許されていないコンテンツのため何も表示しない。
                return null;
            }
            return (React.createElement(PmlAssignmentAccordion, { accordionId: courseIndex + 1 + "-" + (index + 1), className: classes.accordion, courses: group.stages, groupId: group.groupId, key: index, kind: kind, onSelectCourse: onSelectCourse, defaultOpen: defaultOpenIndex === index, title: group.groupTitle, thumbnail: group.thumbnail }));
        })));
};
